import { ChangeEvent, useState } from 'react';
import { Button } from '@/components/Elements';
import { showNotification } from '@/utils/notificationUtils';
import { SimpleHeader } from '@/features/availability/components/SimpleHeader';

import { forgotPasswordandReset } from '../api/forgotPassword';
import Utils from '@/utils/util';
import { Loader } from '@/components/Loader/Loader';

type ForgotPasswordFormProps = {
  onBackClick?: () => void;
  onSuccess?: () => void;
  requiredEmailVerification?: () => void;
};
export const ForgotPassword = ({
  onBackClick,
  onSuccess,
  requiredEmailVerification,
}: ForgotPasswordFormProps) => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.id === 'email') {
      setEmail(event.target.value);
    }
  };

  const validate = () => {
    if (!email || email.trim().length < 1 || !Utils.isValidEmail(email)) {
      showNotification({
        type: 'info',
        title: 'Please enter valid email',
      });
      return false;
    }
    return true;
  };
  return (
    <div className="full-height">
      <div className="top-cotent">
        <SimpleHeader
          onBackClick={() => {
            if (onBackClick) {
              onBackClick();
            }
          }}
          screenTitle="Forgot Password"
        />

        <div className="page-cotent-title"></div>
        <div className="signup-input-tab">
          <div className="input-out-block">
            <input
              id="email"
              type="email"
              value={email}
              className="cust-input-mobile"
              onChange={handleChange}
              placeholder="Enter your email"
            />
          </div>
        </div>
      </div>
      <div className="footer-btn-container">
        <Button
          type="button"
          variant="primary"
          className="w-full inline-flex justify-center rounded-md border profile-new-btn"
          onClick={async () => {
            if (validate()) {
              try {
                await forgotPasswordandReset({
                  email:email.toLowerCase(),
                });
                if (onSuccess) {
                  onSuccess();
                  showNotification({
                    type: 'success',
                    title: 'Please check your email for resetting your password.',
                  });
                }
              } catch (error: any) {
                if (
                  (error && error.response && error.response.data && error.response.data.message) ||
                  (error && error.message)
                ) {
                  let message = error.response?.data?.message || error.message;
                  let errorcode;
                  if (error?.response?.data?.errors && error?.response?.data?.errors?.length > 0) {
                    message = `${error.response?.data?.errors[0]?.message}`;
                    errorcode = error.response?.data?.errors[0]?.code;
                    if (message.includes('field is required') > 0) {
                      message = `${error.response?.data?.errors[0]?.field} ${error.response?.data?.errors[0]?.message}`;
                    }
                    if (errorcode == 'ERR059') {
                      message = `Please enter valid Email address.`;
                    }
                  }
                  if (errorcode && errorcode === 'ERR067' && requiredEmailVerification) {
                    requiredEmailVerification();
                  }
                }
              }
            }
          }}
          disabled={isLoading}
        >
          {isLoading ? <Loader text='submitting...' /> : <span>Continue</span>}
        </Button>
      </div>
    </div>
  );
};
